import { render, staticRenderFns } from "./AgreementFormFrame.vue?vue&type=template&id=4709f648&"
import script from "./AgreementFormFrame.vue?vue&type=script&lang=js&"
export * from "./AgreementFormFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports